import { render, staticRenderFns } from "./ReservationListNext.vue?vue&type=template&id=42519291&"
import script from "./ReservationListNext.vue?vue&type=script&lang=js&"
export * from "./ReservationListNext.vue?vue&type=script&lang=js&"
import style0 from "./ReservationListNext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports